import { Component, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Chart, TooltipItem, registerables } from 'chart.js';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AjaxService } from '../services/ajax.service';
import { TourService } from '../services/tour.service';

interface School {
  name : string,
  id : Number
}


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})

export class DashboardComponent {


  filteredSchools: School[] = [];
  enableFilter = false;
  tnProfChart: any;
  academicChart: any;
  enrChart: any;
  arkChart: any;
  searchText = new FormControl();
  schoolId: number = 0
  averageEnrollment: number = 0

  performance: any = {
    "reading": 0,
    "math": 0
  }

  tnProficiencies: any = {
    "reading": 0,
    "math": 0
  }

  ark: any = {
    "high": 0,
    "moderate": 0,
    "low": 0,
  }

  "enrollment": any = {
    "2014": 0,
    "2015": 0,
    "2016": 0,
    "2017": 0,
    "2018": 0,
    "2019": 0,
    "2020": 0,
    "2021": 0,
    "2022": 0,
    "2023": 0,
    "2024": 0,
  }

  flags: any = {
    "academics": 0,
    "proficienciFlags": 0,
    "ark": 0,
    "enrollment": 0
  }

  academicFlags : any = {}
  proficiencyFlags : any = {}
  arkFlags : any = {}
  enrollmentFlags : any = {}
  showTour : Number = 0

  @ViewChild('tnProficiencyCanvasElement') tnProficiencyCanvasElement: any;
  @ViewChild('academicCanvasElement') academicCanvasElement: any;
  @ViewChild('enrollmentChart') enrollmentChart: any;
  @ViewChild('arkCanvasElement') arkCanvasElement: any;
  constructor(private _userService: UserService, 
    private _router: Router, 
    private _ajaxService : AjaxService,
    public tourService : TourService
  ) {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels)
  }

  ngOnInit() {
    const storedSchools = localStorage.getItem('schools');
    const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
    this.showTour = user.showTour
    if (storedSchools) {
      this.filteredSchools = JSON.parse(storedSchools) as School[];
      if (this._userService.getSchoolId().value != null) {
        let index = this.filteredSchools.findIndex((school: any) => school.schoolId == this._userService.getSchoolId().value);
        this.selectSchool(this.filteredSchools[index])
      } else {
        this.selectSchool(this.filteredSchools[0])
      };
    } else {
      this.filteredSchools = [];
    }
  }

  selectSchool(school: any) {
    if (school != undefined || school != null) {
      this.searchText.setValue(school.name)
      this.schoolId = school.id
      this._userService.setSchoolId(this.schoolId);
      school.isGuestUser === 0 ? this._userService.setUserMenu(true) : this._userService.setUserMenu(false)
      this.enableFilter = false
      this.getSchoolData(this.schoolId)
    }
  }

  ngAfterViewInit() {
    this.drawTnProfChart();
    this.drawEnrollmentChart();
    this.drawArkChart();
    this.drawAcademicChart();
    if (this.showTour === 1) this.tourService.startTour()
    const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
    user['showTour'] = 0
    localStorage.setItem('CSIPUser', JSON.stringify(user))
  }

  ngOnDestroy() {
    this.tnProfChart.destroy();
    this.enrChart.destroy();
    this.arkChart.destroy();
    this.academicChart.destroy();
  }

  drawTnProfChart() {
    let canvas = this.tnProficiencyCanvasElement.nativeElement;
    let ctx = canvas.getContext('2d');
    this.tnProfChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Reading', 'Math'],
        datasets: [
          {
            label: '% student',
            data: [this.tnProficiencies.reading, this.tnProficiencies.math],
            backgroundColor: ['#6BCABA', '#E31C79'],
            borderColor: ['#6BCABA', '#E31C79'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Subject',
            },
            grid: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: 'Proficient',
            },
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          title: {
            display: false,
            text: 'Students Scoring Avg. or Better on NWEA',
          },
          legend: { display: false },
          datalabels: {
            formatter: (value: string, ctx: any) => {
              return value + "%";
            },
            color: 'white',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        },
      },
    });
  }

  drawAcademicChart() {
    let canvas = this.academicCanvasElement.nativeElement;
    let ctx = canvas.getContext('2d');
    this.academicChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Reading', 'Math'],
        datasets: [
          {
            label: '% student',
            data: [this.performance.reading, this.performance.math],
            backgroundColor: ['#6BCABA', '#E31C79'],
            borderColor: ['#6BCABA', '#E31C79'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Subject',
            },
            grid: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: '% Students',
            },
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          title: {
            display: true,
            text: 'Students Scoring Avg. or Better on NWEA',
          },
          legend: { display: false },
          datalabels: {
            formatter: (value: string, ctx: any) => {
              return value + "%";
            },
            color: 'white',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        },
      },
    });
  }

  drawEnrollmentChart() {
    let canvas = this.enrollmentChart.nativeElement;
    let ctx = canvas.getContext('2d');
    let chartLables = [];
    try {
      chartLables = Object.keys(this.enrollment)
    } catch {
      chartLables = [
        '2014',
        '2015',
        '2016',
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
      ];
    }
    if (chartLables.length > 11) {
      chartLables = chartLables.slice(chartLables.length - 11);
    }
    this.enrChart = new Chart(ctx, {
      type: 'bar',
      data: {
        // labels: ['FY 2013', 'FY 2014', 'FY 2015', 'FY 2016', 'FY 2017', 'FY 2018', 'FY 2019', 'FY 2020', 'FY 2021', 'FY 2022', 'FY 2023'],
        labels: chartLables,
        datasets: [
          {
            label: 'Enrollment',
            // data: [50, 60, 70, 80, 90, 100, 110, 112, 113, 114, 115],
            data: chartLables.map((key) => this.enrollment[key]),
            backgroundColor: ['#6BCABA'],
            borderColor: ['#6BCABA'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
        plugins: { 
          legend: { display: false },
          datalabels : {
            color: 'white',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              }
            }
          },
        },
      },
    });
  }

  drawArkChart() {
    let canvas = this.arkCanvasElement.nativeElement;
    let ctx = canvas.getContext('2d');
    this.arkChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [''],
        datasets: [
          {
            barPercentage: 0.5,
            label: 'Low',
            backgroundColor: '#FF0F10',
            data: [this.ark.low],
          },
          {
            barPercentage: 0.5,
            label: 'Moderate',
            backgroundColor: '#fdff00',
            data: [this.ark.moderate],
          },
          {
            barPercentage: 0.5,
            label: 'High',
            backgroundColor: '#4fa716',
            data: [this.ark.high],
          },
        ],
      },
      options: {
        responsive: true,
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            title: {
              display: true,
              text: '% of Students in Score Category',
            },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return value + '%';
              },
            },
            grid: {
              display: true,
            },
          },
          y: {
            stacked: true,
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          title: {
            display: false,
            text: 'I believe that God is present in my life',
          },
          legend: { display: false },
          datalabels: {
            // formatter: (value, ctx) => {
            //   return value + "%";
            // },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              }
            }
          },
          tooltip: {
            callbacks: {
              label: (Item) => {
                return `${Item.dataset.label}: ${Item.formattedValue}%`;
              },
            },
          },
        },
      },
    });
  }

  getSchoolData(schoolId : any) {
    this._ajaxService.get(`school/getSchoolData/${schoolId}`,).then((response: any) => {
      const {performance, ark, tnProficieny, enrollment} = response.data.schoolData;
      const {performanceFlags, arkFlags, tnProficienyFlags} = response.data.flags;
      this.tnProficiencies = tnProficieny
      this.ark = ark
      this.performance = performance
      this.enrollment = enrollment['enrollment']
      this.averageEnrollment = enrollment['avgEnv']

      this.tnProfChart.destroy();
      this.enrChart.destroy();
      this.arkChart.destroy();
      this.academicChart.destroy();

      this.drawTnProfChart();
      this.drawEnrollmentChart();
      this.drawArkChart();
      this.drawAcademicChart();

      this.academicFlags = {...performanceFlags}
      this.proficiencyFlags = {...tnProficienyFlags}
      this.arkFlags = {...arkFlags}
      

      Object.keys(this.academicFlags).forEach((key, value) => {
        if (this.academicFlags[key] == 'Y' || this.academicFlags[key] == 'yes') {
          this.flags['academics']++
        }
      })
      Object.keys(this.proficiencyFlags).forEach((key, value) => {
        if (this.proficiencyFlags[key] == 'Y') {
          this.flags['proficienciFlags']++
        }
      })
      Object.keys(this.arkFlags).forEach((key, value) => {
        if (this.arkFlags[key] == 'Y' || this.arkFlags[key] == 'yes') {
          this.flags['ark']++
        }
      })
      Object.keys(this.enrollmentFlags).forEach((key, value) => {
        if (this.enrollmentFlags[key] == 'Y' || this.enrollmentFlags[key] == 'yes') {
          this.flags['enrollment']++
        }
      })

    })
  }
}
